import { createSlice } from "@reduxjs/toolkit";

const commonSlice = createSlice({
  name: "common",
  initialState: {
    isNavigatedUsingSideNav: true,
    sessionExtend : false,
    TimeoutId:null,
    sessionToken:false,
    offcanvasState: {
      isDrilldownOpen: false,
      title: "",
      dropDownMenuOptions: [],
      selectedValue: {},
      selectedData: [],
      handleDdMenuChange: () => {},
      isDropDownShown:true
    },
    offcanvasThreeState: {
      isDrilldownThreeOpen: false,
      locDrilldown:false,
      title: "",
      static:false,
      // dropDownMenuOptions: [],
      // selectedValue: {},
      selectedData: [],
      //handleDdMenuChange: () => {},
      isDropDownShown:true
    },
    accordionModal :{
       accordionData:[]
    },
    offcanvasLastState: {
      isDrilldownLastOpen: false,
      //locDrilldown:false,
      title: "",
      static:false,
      // dropDownMenuOptions: [],
      // selectedValue: {},
      selectedData: [],
      //handleDdMenuChange: () => {},
      isDropDownShown:true
    },
    drillDownSelectionState: {
      selectedLevelOne: "",
    },
    completeTable: {
      limit: 10,
      pageNo:0,
      pageCount:"",
      listCount:"",
      activeKey:"",
      searchKey:"",
      filterKey:"",
    },
    loggedUser:{
      userName:"",
      userRole:"",
      userMail:"",
      displayName:"",
      showLM: false,
      showSirar: false,
      showContainerCost: false,
      showBM: false,
      showRitm: false,
      showInc: false,
      token:""
    },
    commonAlert:{
      openAlert:false,
      alertType:"",
      alertMessage:"",
    },
    UserMail:{
      mailId:""
    },
    isReload:"false",
    assessmentData:[],
    selectedIds:[],
    pageLoading:true,
    activeUrl:"",
    tableReload:false
  },
  reducers: {
    setIsOffCanvasOpen: {
      reducer(state, action) {
        state.offcanvasState = action.payload;
      },
    },
    setIsOffCanvasThreeOpen: {
      reducer(state, action) {
        state.offcanvasThreeState = action.payload;
      },
    },
    setIsOffCanvasLastOpen: {
      reducer(state, action) {
        state.offcanvasLastState = action.payload;
      },
    },
    setSelectedLevelOne: {
      reducer(state, action) {
        state.drillDownSelectionState.selectedLevelOne = action.payload;
      },
    },
    setAccordionData:{
      reducer(state,action){
        state.accordionModal.accordionData=action.payload;
      }
    },
    setCompleteTableLimit: {
      reducer(state, action) {
        state.completeTable.limit = action.payload;
      },
    },
    setCompleteTablePageNo: {
      reducer(state, action) {
        state.completeTable.pageNo = action.payload;
      },
    },
    setCompleteTablepageCount: {
      reducer(state, action) {
        state.completeTable.pageCount = action.payload;
      },
    },
    setCompleteTablelistCount: {
      reducer(state, action) {
        state.completeTable.listCount = action.payload;
      },
    },
    setCompleteTableactiveKey: {
      reducer(state, action) {
        state.completeTable.activeKey = action.payload;
      },
    },
    setCompleteTableSearchKey: {
      reducer(state, action) {
        state.completeTable.searchKey = action.payload;
      },
    },
    setCompleteTableFilterKey: {
      reducer(state, action) {
        state.completeTable.filterKey = action.payload;
      },
    },
    hideOffCanvas: {
      reducer(state, action) {
        state.offcanvasState.isDrilldownOpen = action.payload;
      },
    },
    hideOffCanvasThree: {
      reducer(state, action) {
        state.offcanvasThreeState.isDrilldownThreeOpen = action.payload;
      },
    },
    hideOffCanvasLast: {
      reducer(state, action) {
        state.offcanvasLastState.isDrilldownLastOpen = action.payload;
      },
    },
    
    locdrilldownthree: {
      reducer(state, action) {
        state.offcanvasThreeState.locDrilldown = action.payload;
      },
    },
    setSelectedDdMenuValue: {
      reducer(state, action) {
        state.offcanvasState.selectedValue = action.payload;
      },
    },
    setSelectedData: {
      reducer(state, action) {
        state.offcanvasState.selectedData = action.payload;
      },
    },
    setLoggedUser:{
      reducer(state,action){
        state.loggedUser = action.payload
      }
    },
    setCommonAlert:{
      reducer(state,action){
        state.commonAlert = action.payload
      }
    },
    resetLoggedUser: {
      reducer(state, action) {
        state.loggedUser = {
          userName:"",
          userRole:"",
          userMail:"",
          displayName:"",
          showLM: '',
          showSirar:"",
          showContainerCost:"",
          showBM:"",
          showRitm:"",
          showInc:"",
          token:""
        };
        state.isNavigatedUsingSideNav = true;
      }
    },
    setUserMail:{
      reducer(state,action){
        state.UserMail = action.payload
      }
    },
    setIsReload:{
      reducer(state,action){
        state.isReload = action.payload
      }
    },
    setAssessmentData:{
      reducer(state,action){
        state.assessmentData = action.payload
      }
    },
    setSelectedIds:{
      reducer(state,action){
        state.selectedIds = action.payload
      }
    },
    setPageLoading:{
      reducer(state,action){
        state.pageLoading = action.payload
      }
    },
    setActiveUrl:{
      reducer(state,action){
        state.activeUrl = action.payload
      }
    },
    setTableReload:{
      reducer(state,action){
        state.tableReload = action.payload
      }
    },
    setNavigationClicked: {
      reducer(state, action) {
        state.isNavigatedUsingSideNav = action.payload;
      }
    },
    setSessionExtend: {
      reducer(state, action) {
        state.sessionExtend = action.payload;
      }
    },
    setTimeoutId: {
      reducer(state, action) {
        state.TimeoutId = action.payload;
      }
    },
    setsessionToken: {
      reducer(state, action) {
        state.sessionToken = action.payload;
      }
    }
  },
});
export const {
  setIsOffCanvasOpen,
  setIsOffCanvasThreeOpen,
  setIsOffCanvasLastOpen,
  setSelectedLevelOne,
  setCompleteTableLimit,
  setCompleteTablePageNo,
  setCompleteTablepageCount,
  setCompleteTablelistCount,
  setCompleteTableactiveKey,
  setCompleteTableSearchKey,
  setCompleteTableFilterKey,
  hideOffCanvas,
  hideOffCanvasThree,
  hideOffCanvasLast,
  locdrilldownthree,
  setSelectedDdMenuValue,
  setSelectedData,
  setLoggedUser,
  setCommonAlert,
  setUserMail,
  setIsReload,
  setPageLoading,
  setActiveUrl,
  setTableReload,
  setAssessmentData,
  setSelectedIds,
  setAccordionData,
  setNavigationClicked,
  resetLoggedUser,
  setSessionExtend,
  setTimeoutId,
  setsessionToken
} = commonSlice.actions;


export default commonSlice.reducer;
